import React from "react";
import NotFoundFullScreenMessage from "../components/fullScreenMessage/NotFoundFullScreenMessage";
import { useGetTableAppointments } from "../hooks/useGetAppointments";
import { useSearchParams } from "react-router-dom";
import {
  appointmentParamKeys,
  orderStrings,
} from "../features/admin/appointments/components/DesktopReservations";
import { STATUSES } from "../enums/AppointmentStatus";

export const AppointmentFilteringContext = React.createContext();

export default function AppointmentFiltering({ children }) {
  const { data, isLoading, error,size } = useGetTableAppointments();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);

  function handleWildCardData(value) {
    if (value != null && value != "" && value != undefined) {
      params.set(appointmentParamKeys.search, String(value));
      params.set(appointmentParamKeys.tablePage, 0);
      setSearchParams(params);
    } else {
      params.delete(appointmentParamKeys.search);
      params.set(appointmentParamKeys.tablePage, 0);
      setSearchParams(params);
    }
  }

  function handleStatusFiltering(selectedStatus) {
    const statusParams = params.get(appointmentParamKeys.status);
    const prev = statusParams ? statusParams.split("+") : [];

    let newStatus;

    if (prev.includes(String(selectedStatus))) {
      newStatus = prev.filter(
        (stat) => String(stat) !== String(selectedStatus)
      );
    } else {
      newStatus = [...prev, String(selectedStatus)];
    }

    if (newStatus.length > 0) {
      params.set(appointmentParamKeys.status, newStatus.join("+"));
    } else if (newStatus.length > 1) {
      params.delete(appointmentParamKeys.status);
    }
    params.set(appointmentParamKeys.tablePage, 0);
    setSearchParams(params);
  }

  function resetFilter() {
    searchParams.set(appointmentParamKeys.tablePage, 0);
    params.delete(appointmentParamKeys.endDate);
    params.delete(appointmentParamKeys.startDate);
    params.delete(appointmentParamKeys.search);
    params.delete(appointmentParamKeys.status);
    params.delete(orderStrings.date);
    params.delete(orderStrings.email);
    params.delete(orderStrings.pet);
    params.delete(orderStrings.phone);
    params.delete(orderStrings.service);
    params.delete(orderStrings.status);
    setSearchParams(params);
    handleStatusFiltering(STATUSES.ACTIVE);
  }

  const values = {
    handleStatusFiltering,
    resetFilter,
    handleWildCardData,
    data,
    isLoading,
    error,
    size
  };

  React.useEffect(() => {
    if (searchParams.get(appointmentParamKeys.status) == null) {
      searchParams.set(appointmentParamKeys.status, STATUSES.ACTIVE);
      setSearchParams(searchParams);
    }
  }, []);

  if (error) {
    return <NotFoundFullScreenMessage testId="appointments.filtering.error-message" />;
  }

  return (
    <AppointmentFilteringContext.Provider value={values}>
      {children}
    </AppointmentFilteringContext.Provider>
  );
}
